<template>
  <div v-if="shouldShowDetails" class="mt-4">
    <h4 class="text-xs font-semibold uppercase tracking-wide text-slate-500 dark:text-slate-400 mb-2">
      {{ $t('AUDIT_LOGS.DETAILS.TITLE') }}
    </h4>
    <div v-if="isSchoolEnrollment" class="grid grid-cols-1 gap-3 sm:grid-cols-2">
      <div
        v-for="detail in renderedDetails"
        :key="detail.label"
        class="flex flex-col rounded border border-slate-200/60 bg-slate-50/60 p-3 text-sm dark:border-slate-700 dark:bg-slate-800"
      >
        <span class="text-xs font-medium uppercase text-slate-500 dark:text-slate-400">
          {{ detail.label }}
        </span>
        <span class="mt-1 text-slate-900 dark:text-slate-100">
          {{ detail.value }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AuditLogDetails',
  props: {
    auditLogItem: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isSchoolEnrollment() {
      return this.auditLogItem?.auditable_type === 'SchoolEnrollment';
    },
    details() {
      if (!this.isSchoolEnrollment) {
        return {};
      }

      const changes = this.auditLogItem.audited_changes || {};

      return {
        studentName: changes.student_name || changes.studentName,
        responsibleName: changes.responsible_name || changes.responsibleName,
        enrollmentNumber: changes.number,
        schoolYear: changes.school_year || changes.schoolYear,
        schoolDocument:
          changes.enrollment_school_document || changes.enrollmentSchoolDocument,
        schoolClass: changes.school_class || changes.schoolClass,
      };
    },
    renderedDetails() {
      if (!this.isSchoolEnrollment) {
        return [];
      }

      const mapping = [
        {
          key: 'studentName',
          label: this.$t(
            'AUDIT_LOGS.DETAILS.SCHOOL_ENROLLMENT.STUDENT_NAME'
          ),
        },
        {
          key: 'responsibleName',
          label: this.$t(
            'AUDIT_LOGS.DETAILS.SCHOOL_ENROLLMENT.RESPONSIBLE_NAME'
          ),
        },
        {
          key: 'enrollmentNumber',
          label: this.$t(
            'AUDIT_LOGS.DETAILS.SCHOOL_ENROLLMENT.ENROLLMENT_NUMBER'
          ),
        },
        {
          key: 'schoolYear',
          label: this.$t(
            'AUDIT_LOGS.DETAILS.SCHOOL_ENROLLMENT.SCHOOL_YEAR'
          ),
        },
        {
          key: 'schoolDocument',
          label: this.$t(
            'AUDIT_LOGS.DETAILS.SCHOOL_ENROLLMENT.SCHOOL_DOCUMENT'
          ),
        },
        {
          key: 'schoolClass',
          label: this.$t(
            'AUDIT_LOGS.DETAILS.SCHOOL_ENROLLMENT.SCHOOL_CLASS'
          ),
        },
      ];

      return mapping
        .filter(item => this.details[item.key])
        .map(item => ({
          label: item.label,
          value: this.details[item.key],
        }));
    },
    shouldShowDetails() {
      if (!this.isSchoolEnrollment) {
        return false;
      }

      return Object.values(this.details).some(value => Boolean(value));
    },
  },
};
</script>
